import React from 'react'
import { Link } from 'react-router-dom'

const index = ({link, background, style, value, blue}) => {
  return (
    <Link className={blue ? `${background} rounded-[20px] h-[35px] w-[106px] md:w-[130px] md:h-[40px] flex items-center justify-center bg-lightBlue` : ` shadow-blackShadow rounded-[20px] h-[35px] w-[106px] md:w-[130px] md:h-[40px] flex items-center justify-center bg-lightBlue `} to={link}>
    <button className={blue ? `${style} text-[12px] md:text-[16px] px-[15px] py-[10px]` : ` text-[12px] md:text-[16px] px-[15px] py-[10px]`}>{value}</button>
    </Link>
  )
}

export default index